import { useEffect, useState } from "react";
import { useMe } from "@/data/user.ts";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { feedbackOptions } from "@/data/static/agenda";
import { FeedbackProps, AgendaFeedbackState } from "@/types";
import FirstPage from "@/components/agenda/mobile/feedback/FirstPage.tsx";
import SecondPage from "@/components/agenda/mobile/feedback/SecondPage.tsx";
import FourthPage from "@/components/agenda/mobile/feedback/FourthPage.tsx";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

const FeedbackAgenda = () => {
  const { me } = useMe();
  const { setGlobalState } = useGlobals();

  const location = useLocation();
  const data = location?.state as AgendaFeedbackState;

  const [active, setActiveTab] = useState(0);

  const [comment, setComment] = useState<string | undefined>(undefined);
  const [feedback, setFeedback] = useState<FeedbackProps>({
    id_user: me?.item.user.id || 0,
    id_evento: data.idEvent,
    rating: {
      tutor: 0,
      topicAndOrganization: 0,
    },
  });

  const nextPage = (stars: { tutor: number; topicAndOrganization: number }) => {
    setFeedback((r) => {
      r.rating = stars;
      return r;
    });

    if (stars.tutor < 4 && stars.topicAndOrganization < 4) {
      setActiveTab(2);
    } else if (
      stars.tutor < 4 ||
      stars.topicAndOrganization < 4 ||
      (stars.tutor === 5 && stars.topicAndOrganization === 5)
    ) {
      setActiveTab(1);
    } else {
      setActiveTab(1);
    }
  };

  const feedbackAreas: Array<keyof typeof feedbackOptions> = [];

  if (feedback.rating.tutor <= 4) {
    feedbackAreas.push("Tutor");
  }

  if (feedback.rating.topicAndOrganization <= 4) {
    feedbackAreas.push("Topic and organization");
  }

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-light");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardContentLayout>
      <AnimatePresence>
        {active === 0 && <FirstPage nextPage={nextPage} />}

        {active === 1 && (
          <SecondPage
            comment={comment}
            feedback={feedback}
            nextPage={() => setActiveTab(2)}
            setComment={setComment}
            setActiveTab={setActiveTab}
          />
        )}

        {active === 2 && (
          <FourthPage
            type={data.type}
            comment={comment}
            feedback={feedback}
            activeTab={active}
            setActiveTab={setActiveTab}
            feedbackAreas={feedbackAreas}
          />
        )}
      </AnimatePresence>
    </DashboardContentLayout>
  );
};

export default FeedbackAgenda;
